<template>
    <div :class="prefixCls">
        <slot
            v-bind="{
                model: finalModel,
                readonly: finalReadonly,
                disabled: finalDisabled,
                viewonly: finalViewonly,
                editable: finalEditable,
                required: finalRequired,
                prop: finalProp,
                rules: finalRules,
                hasRuleRequired,
            }"
        ></slot>
    </div>
</template>
<script>
import Field from '../../mixins/field'

const prefixCls = 'ivu-field-group'

export default {
    name: 'FieldGroup',
    mixins: [Field],
    props: {
        // @override
        ruleInherit: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        prefixCls() {
            return prefixCls
        },
    },
}
</script>
